const actions = {
  resetRecaptchaV2Action({ getters }, recaptchaComponent) {
    if (!getters.canUseGoogleRecaptchaV3 && recaptchaComponent) {
      recaptchaComponent.reset()
    }
  },
}

export default actions
